import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { IShowMessageBoxParams, MessageBoxAnswer, MessageBoxService } from "./message-box.service";
import { ReplacePipe } from "./replace.pipe";


@Component({
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    standalone: true,
    imports: [
        MatCardModule,
        MatButtonModule,
        TranslateModule,
        CommonModule,
        MatIconModule,
        ReplacePipe
    ]
})
export class MessageBoxComponent {

    readonly typeToIcon: { [type in IShowMessageBoxParams['type']]: string } = {
        info: 'info',
        prompt: 'info',
        warning: 'warning'
    }

    get icon() {
        return this.typeToIcon[this.params.type]
    }

    readonly typeToTitle: { [type in IShowMessageBoxParams['type']]: string } = {
        info: 'ss-message-box.info',
        prompt: 'ss-message-box.prompt',
        warning: 'ss-message-box.warning'
    }

    get title() {
        return this.params.title || this.typeToTitle[this.params.type]
    }

    readonly typeToColor: { [type in IShowMessageBoxParams['type']]: string } = {
        info: 'primary',
        prompt: 'accent',
        warning: 'warn'
    }
    get color() {
        return this.typeToColor[this.params.type]
    }

    get no() {
        return this.params.no || 'ss-general.no'
    }

    get yes() {
        return this.params.yes || 'ss-general.yes'
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) public readonly params: IShowMessageBoxParams,
        private readonly _messageBoxService: MessageBoxService
    ) {

    }

    close(answer: MessageBoxAnswer) {
        this._messageBoxService.close(answer);
    }
}